import { SearchModel, SearchType } from '@nrwl/rx-models';

import { Action } from '@ngrx/store';
import { FormCategory } from 'libs/models/form/form-category';
import { FormPagerQueryModel } from 'libs/models/form/form-pager-query.model';
import { FormTemplate } from 'libs/models/form/form-template';
import { FormCategoryQueryParams } from 'libs/models/form/form-category-query-params';
import { PaginatedApiResponse } from 'libs/models/pagination/paginated-api-response';

export enum FormActionsTypes {
  LoadForms = '[Manager] Load forms',
  LoadFormsSuccess = '[Manager] Load forms success',
  LoadFormsFail = '[Manager] Load forms fail',

  LoadFormTemplateById = '[Manager] Load FormTemplate by Id',
  LoadFormTemplateByIdSuccess = '[Manager] Load FormTemplate by Id Success',

  PreviewFormTemplate = '[Manager] Preview FormTemplate by Id',
  PreviewPhoneFormTemplate = '[Manager] Preview Phone FormTemplate by Id',
  PreviewFormTemplateOpened = '[Manager] Preview FormTemplate opened',

  SearchForms = '[Manager] Search Forms',
  SearchGlobalLibraryTemplates = '[Manager] Search Global Library Templates',
  SearchAccountLibraryTemplates = '[Manager] Search Account Library Templates',
  LoadFormsByNameSuccess = '[Manager] Load forms by name success',
  ResetSearch = '[Manager] Reset search',
  ResetGlobalLibrarySearch = '[Manager] Reset global library search',
  ResetAccountLibrarySearch = '[Manager] Reset account library search',
  ResetSearchSuccess = '[Manager] Reset search success',

  LoadCategoryById = '[Manager] Load category by id',
  LoadCategoryByIdSuccess = '[Manager] Load category by id success',

  // TODO: Rethink this. Try using selector first.
  FilterCategories = '[Manager] Load filter categories',

  CategoryEntry = '[Manager] Show add category dialog',
  ActivityEntry = '[Manager] Show activity dialog',

  LoadSelectedTemplate = '[Manager] load current template',
  SetSelectedTemplate = '[Manager] set current template',

  SetCategoryId = '[Manager] Set category id for dialog',
  SetFormId = '[Manager] Set form id for dialog',

  SelectCategory = '[Manager] Select category',
  SelectCategories = '[Manager] Select categories',
  SelectCategoriesSuccess = '[Manager] Select categories success',
  ResetCategoriesSelection = '[Manager] Reset categories selection',
  DeselectCategories = '[Manager] Deselect categories',

  CreateCategory = '[Manager] Create category',
  CreateCategorySuccess = '[Manager] Create category success',
  CreateCategoryFail = '[Manager] Create category fail',

  UpdateCategory = '[Manager] Update category',
  UpdateCategorySuccess = '[Manager] Update category success',
  UpdateCategoryFail = '[Manager] Update category fail',

  DeleteCategory = '[Manager] Delete category',
  DeleteCategorySuccess = '[Manager] Delete category success',
  DeleteCategoryFail = '[Manager] Delete category fail',

  SortCategory = '[Manager] Sort category',
  SortCategorySuccess = '[Manager] Sort category success',

  CreateForm = '[Manager] Create Form',
  CreateFormSuccess = '[Manager] Create Form success',
  CreateFormFail = '[Manager] Create Form fail',

  CloneForm = '[Manager] Clone single FormTemplate',
  CloneFormSuccess = '[Manager] Clone single FormTemplate success',

  UpdateForm = '[Manager] Update Form',
  UpdateFormSuccess = '[Manager] Update Form success',
  UpdateFormFail = '[Manager] Update Form fail',

  PublishTemplates = '[Manager] Publish Form Template',
  PublishTemplatesSuccess = '[Manager] Publish Form Template Success',

  StopPublishingTemplates = '[Manager] Stop Publishing Form Template',
  StopPublishingTemplatesSuccess = '[Manager] Stop Publishing Form Template Success',

  DeleteForms = '[Manager] Delete Form',
  DeleteFormsSuccess = '[Manager] Delete Form success',
  DeleteFormsFail = '[Manager] Delete Form fail',

  DeleteFormTemplatesById = '[Manager] Delete Form Template by id',
  DeleteFormTemplatesByIdSuccess = '[Manager] Delete Form Template by id success',
  RecalculateCategoryCountsAfterArchive = '[Manager] Recalculate category counts after archive',
  RecalculateCategoryCountsAfterMove = '[Manager] Recalculate category counts after move',
  RecalculateCategoryCountsAfterClone = '[Manager] Recalculate category counts after clone',

  CloneForms = '[Manager] Clone form',
  CloneFormsSuccess = '[Manager] Clone success',

  CloneFormsUsingIds = '[Manager] Clone form using ids',

  SaveAsCopy = '[Manager] Save as copy',
  SaveAsCopySuccess = '[Manager] Save as copy success',

  MoveForm = '[Manager] move form',
  MoveFormBulk = '[Manager] move form bulk',
  MoveFormSuccess = '[Manager] move success',
  MoveTemplatesLocallySuccess = '[Manager] move templates locally success',
  AddClonedTemplatesLocallySuccess = '[Manager] add cloned templates locally success',

  SortTemplates = '[Manager] Sort templates',
  SortTemplatesSuccess = '[Manager] Sort templates success',

  LoadArchive = '[Manager] load archive Form',
  LoadArchiveSuccess = '[Manager] load archive Form success',
  LoadArchiveFail = '[Manager] load archive forms fail',

  LoadUploaded = '[Manager] Load uploaded forms',
  LoadUploadedSuccess = '[Manager] Load uploaded forms ssuccess',
  LoadUploadedFail = '[Manager] Load uploaded forms fail',

  LoadGlobalUploaded = '[Manager] LoadGlobalUploaded',
  LoadGlobalUploadedSuccess = '[Manager] LoadGlobalUploadedSuccess',

  LoadPracticeTemplates = '[Manager] LoadPracticeTemplates',
  LoadPracticeTemplatesSuccess = '[Manager] LoadPracticeTemplatesSuccess',
  LoadPracticeTemplatesFailed = '[Manager] LoadPracticeTemplatesFailed',

  LoadPracticeArchive = '[Manager] LoadPracticeArchive',
  LoadPracticeArchiveSuccess = '[Manager] LoadPracticeArchiveSuccess',
  LoadPracticeArchiveFailed = '[Manager] LoadPracticeArchiveFailed',

  LoadGlobalCategories = '[Manager] Load global categories',
  LoadMoreGlobalCategories = '[Manager] Load more global categories',
  LoadGlobalCategoriesSuccess = '[Manager] Load global categories success',
  LoadGlobalCategoriesFail = '[Manager] Load global categories fail',

  LoadAccountCategories = '[Manager] Load account categories',
  LoadMoreAccountCategories = '[Manager] Load more account categories',
  LoadAccountCategoriesSuccess = '[Manager] Load account categories success',
  LoadAccountCategoriesFail = '[Manager] Load account categories fail',

  LoadDialogAccountCategories = '[Manager] Load dialog account categories',
  CancelDialogAccountCategories = '[Manager] Cancel dialog account categories',
  LoadDialogAccountCategoriesSuccess = '[Manager] Load dialog account categories success',
  LoadDialogAccountCategoriesFail = '[Manager] Load dialog account categories fail',

  LoadDialogGlobalCategories = '[Manager] Load dialog global categories',
  CancelDialogGlobalCategories = '[Manager] Cancel dialog global categories',
  LoadDialogGlobalCategoriesSuccess = '[Manager] Load dialog global categories success',
  LoadDialogGlobalCategoriesFail = '[Manager] Load dialog global categories fail',

  SearchGlobalCategories = '[Manager] Search global categories',
  SearchGlobalCategoriesSuccess = '[Manager] Search global categories success',
  SearchGlobalCategoriesFail = '[Manager] Search global categories fail',

  SearchAccountCategories = '[Manager] Search account categories',
  SearchAccountCategoriesSuccess = '[Manager] Search account categories success',
  SearchAccountCategoriesFail = '[Manager] Search account categories fail',

  RestoreForm = '[Manager] Restore Form',
  RestoreFormSuccess = '[Manager] Restore Form success',

  RestoreUploadedForm = '[Manager] RestoreUploadedForm',
  RestoreUploadedFormSuccess = '[Manager] RestoreUploadedFormSuccess',

  RestorePracticeTemplates = '[Manager] RestorePracticeTemplates',
  RestorePracticeTemplatesSuccess = '[Manager] RestorePracticeTemplatesSuccess',

  Reload = '[Manager] Reload',
  ResetFormsManagerState = '[Manager] Reset forms manager state',

  Error = '[Manager] set error',
  DeleteError = '[Manager] delete error',

  EnableSpinner = '[Manager] Enable Spinner',
  DisableSpinner = '[Manager] Disable Spinner',

  FixMediaIssue = '[Manager] Fix Media Issue',

  DeselectCategoryByType = '[Manager] Deselect categories by type',
  ClearBusyTemplates = '[Template] Clear busy templates',
  SelectBusyTemplate = '[Template] Select busy template',
  AddBusySearchType = '[Template] Add busy search type',
  RemoveBusySearchType = '[Template] Remove busy search type',

  DeselectTemplates = '[Manager] Deselect templates',
}

// #region Categories

// #region LOAD CATEGORIES

export class LoadCategoryById implements Action {
  readonly type = FormActionsTypes.LoadCategoryById;
  constructor(public payload: number) {}
}

export class LoadCategoryByIdSuccess implements Action {
  readonly type = FormActionsTypes.LoadCategoryByIdSuccess;
  constructor(public payload: FormCategory) {}
}

// #endregion

export class FilterCategories implements Action {
  readonly type = FormActionsTypes.FilterCategories;
  constructor(public payload: number[]) {}
}

export class CategoryEntry implements Action {
  readonly type = FormActionsTypes.CategoryEntry;
  constructor(public payload: FormCategory) {}
}

export class ActivityEntry implements Action {
  readonly type = FormActionsTypes.ActivityEntry;
  constructor(public payload: any) {}
}

// SELECT TEMPLATE

export class LoadSelectedTemplate implements Action {
  readonly type = FormActionsTypes.LoadSelectedTemplate;
  constructor(public payload: any) {}
}

export class SetSelectedTemplate implements Action {
  readonly type = FormActionsTypes.SetSelectedTemplate;
  constructor(public payload: FormTemplate) {}
}

// #region SELECT CATEGORY

export class SelectCategory<T> implements Action {
  readonly type = FormActionsTypes.SelectCategory;
  constructor(
    public payload?: FormCategory,
    public callbackAction?: T,
  ) {}
}

// Pre-process selected categories in Effect
export class SelectCategories implements Action {
  readonly type = FormActionsTypes.SelectCategories;
  constructor(
    public payload?: number[],
    public searchType?: SearchType,
    public reset?: boolean,
    public preserveSelection?: boolean,
    public skipLoadForms = false,
  ) {}
}

// Call select action from effect
export class SelectCategoriesSuccess implements Action {
  readonly type = FormActionsTypes.SelectCategoriesSuccess;
  constructor(
    public payload?: number[],
    public preserveSelection?: boolean,
  ) {}
}

export class ResetCategoriesSelection implements Action {
  readonly type = FormActionsTypes.ResetCategoriesSelection;
  constructor(public payload: SearchType) {}
}

export class DeselectCategories implements Action {
  readonly type = FormActionsTypes.DeselectCategories;
}

export class DeselectCategoryByType implements Action {
  readonly type = FormActionsTypes.DeselectCategoryByType;
  constructor(public payload: number[]) {}
}

// #endregion

// #region CREATE CATEGORY

export class CreateCategory implements Action {
  readonly type = FormActionsTypes.CreateCategory;
  constructor(public payload: FormCategory) {}
}

export class CreateCategorySuccess implements Action {
  readonly type = FormActionsTypes.CreateCategorySuccess;
  constructor(public payload: FormCategory) {}
}

export class CreateCategoryFail implements Action {
  readonly type = FormActionsTypes.CreateCategoryFail;
  constructor(public payload: string) {}
}

// #endregion

// #region UPDATE CATEGORY

export class UpdateCategory implements Action {
  readonly type = FormActionsTypes.UpdateCategory;
  constructor(
    public payload: FormCategory,
    public reload = false,
  ) {}
}

export class UpdateCategorySuccess implements Action {
  readonly type = FormActionsTypes.UpdateCategorySuccess;
  constructor(public payload: FormCategory) {}
}

export class UpdateCategoryFail implements Action {
  readonly type = FormActionsTypes.UpdateCategoryFail;
  constructor(public payload: string) {}
}

// #endregion

// #region DELETE CATEGORY

export class DeleteCategory implements Action {
  readonly type = FormActionsTypes.DeleteCategory;
  constructor(public payload: FormCategory) {}
}

export class DeleteCategorySuccess implements Action {
  readonly type = FormActionsTypes.DeleteCategorySuccess;
  constructor(public payload: FormCategory) {}
}

export class DeleteCategoryFail implements Action {
  readonly type = FormActionsTypes.DeleteCategoryFail;
  constructor(public payload: string) {}
}

// #endregion

export class SortCategory implements Action {
  readonly type = FormActionsTypes.SortCategory;
  constructor(
    public payload: FormCategory,
    public fromIndex: number,
    public toIndex: number,
    public searchType: SearchType,
  ) {}
}

export class SortCategorySuccess implements Action {
  readonly type = FormActionsTypes.SortCategorySuccess;
  constructor(public payload: FormCategory[]) {}
}

// #region CREATE FORM

export class CreateForm implements Action {
  readonly type = FormActionsTypes.CreateForm;
  constructor(
    public payload: FormTemplate,
    public suppressToast = false,
  ) {}
}

export class CreateFormSuccess implements Action {
  readonly type = FormActionsTypes.CreateFormSuccess;
  constructor(
    public payload: FormTemplate,
    public suppressToast = false,
  ) {}
}

export class CreateFormFail implements Action {
  readonly type = FormActionsTypes.CreateFormFail;
  constructor(
    public payload: string,
    public failedTemplate?: FormTemplate,
  ) {}
}

// #endregion

// #region CREATE FORM

export class CloneForm implements Action {
  readonly type = FormActionsTypes.CloneForm;
  constructor(public payload: FormTemplate) {}
}

export class CloneFormSuccess implements Action {
  readonly type = FormActionsTypes.CloneFormSuccess;
  constructor(public payload: FormTemplate) {}
}

// #endregion

// #region UPDATE FORM

export class UpdateForm implements Action {
  readonly type = FormActionsTypes.UpdateForm;
  constructor(
    public payload: FormTemplate,
    public reloadList = false,
    public suppressToast = false,
  ) {}
}

export class UpdateFormSuccess implements Action {
  readonly type = FormActionsTypes.UpdateFormSuccess;
  constructor(
    public payload: FormTemplate,
    public suppressToast = false,
  ) {}
}

export class UpdateFormFail implements Action {
  readonly type = FormActionsTypes.UpdateFormFail;
  constructor(
    public payload: string,
    public failedTemplate?: FormTemplate,
  ) {}
}

// #endregion

export class PublishTemplates implements Action {
  readonly type = FormActionsTypes.PublishTemplates;
  readonly info = 'Publishing Template...';
  constructor(
    public payload: FormTemplate[],
    public completed: FormTemplate[] = [],
  ) {}
}

export class PublishTemplatesSuccess implements Action {
  readonly type = FormActionsTypes.PublishTemplatesSuccess;
  readonly success = 'Template(s) published!';
  constructor(public payload: FormTemplate[]) {}
}

export class StopPublishingTemplates implements Action {
  readonly type = FormActionsTypes.StopPublishingTemplates;
  readonly info = 'Unpublishing Template(s)...';
  constructor(
    public payload: FormTemplate[],
    public completed: FormTemplate[] = [],
  ) {}
}

export class StopPublishingTemplatesSuccess implements Action {
  readonly type = FormActionsTypes.StopPublishingTemplatesSuccess;
  readonly success = 'Template(s) unpublished!';
  constructor(public payload: FormTemplate[]) {}
}

// #region DELETE FORM

export class DeleteForms implements Action {
  readonly type = FormActionsTypes.DeleteForms;
  constructor(public payload: any[]) {}
}

export class DeleteFormsSuccess implements Action {
  readonly type = FormActionsTypes.DeleteFormsSuccess;
  constructor(public payload: any) {}
}

export class DeleteFormsFail implements Action {
  readonly type = FormActionsTypes.DeleteFormsFail;
  constructor(public payload: string) {}
}

export class DeleteFormTemplatesById implements Action {
  readonly type = FormActionsTypes.DeleteFormTemplatesById;
  constructor(public payload: any[]) {}
}

export class DeleteFormTemplatesByIdSuccess implements Action {
  readonly type = FormActionsTypes.DeleteFormTemplatesByIdSuccess;
  constructor(public payload: any[]) {}
}

export class RecalculateCategoryCountsAfterArchive implements Action {
  readonly type = FormActionsTypes.RecalculateCategoryCountsAfterArchive;
  constructor(public payload: FormTemplate[]) {}
}

export class RecalculateCategoryCountsAfterMove implements Action {
  readonly type = FormActionsTypes.RecalculateCategoryCountsAfterMove;
  constructor(public payload: { templates: FormTemplate[]; destinationCategoryId: number }) {}
}

export class RecalculateCategoryCountsAfterClone implements Action {
  readonly type = FormActionsTypes.RecalculateCategoryCountsAfterClone;
  constructor(public payload: { templates: FormTemplate[]; destinationCategoryId: number }) {}
}

// #endregion

// #region Clone
export class CloneForms implements Action {
  readonly type = FormActionsTypes.CloneForms;
  constructor(
    public category: FormCategory,
    public forms: FormTemplate[],
    public options?,
  ) {}
}

export class CloneFormsSuccess implements Action {
  readonly type = FormActionsTypes.CloneFormsSuccess;
  constructor(public payload?: any) {}
}

export class CloneFormsUsingIds implements Action {
  readonly type = FormActionsTypes.CloneFormsUsingIds;
  constructor(
    public categoryId: number,
    public formTemplateIds: number[],
    public searchType: SearchType,
  ) {}
}

export class SaveAsCopy implements Action {
  readonly type = FormActionsTypes.SaveAsCopy;
  constructor(
    public category: FormCategory,
    public form: FormTemplate,
  ) {}
}

export class SaveAsCopySuccess implements Action {
  readonly type = FormActionsTypes.SaveAsCopySuccess;
  constructor(public formTemplate: FormTemplate) {}
}

// #endregion

// #region Clone

export class MoveForm implements Action {
  readonly type = FormActionsTypes.MoveForm;
  constructor(
    public category: FormCategory,
    public forms: FormTemplate[],
  ) {}
}

export class MoveFormBulk implements Action {
  readonly type = FormActionsTypes.MoveFormBulk;
  constructor(public payload: any) {}
}

export class MoveFormSuccess implements Action {
  readonly type = FormActionsTypes.MoveFormSuccess;
}

export class MoveTemplatesLocallySuccess implements Action {
  readonly type = FormActionsTypes.MoveTemplatesLocallySuccess;
  constructor(public payload: { templates: FormTemplate[]; destinationCategoryId: number }) {}
}

export class AddClonedTemplatesLocallySuccess implements Action {
  readonly type = FormActionsTypes.AddClonedTemplatesLocallySuccess;
  constructor(public payload: { templates: FormTemplate[]; destinationCategoryId: number }) {}
}

// #endregion

// #region Sort Form

export class SortTemplates implements Action {
  readonly type = FormActionsTypes.SortTemplates;
  constructor(
    public payload: FormTemplate,
    public fromIndex: number,
    public toIndex: number,
    public searchType: SearchType,
  ) {}
}

export class SortTemplatesSuccess implements Action {
  readonly type = FormActionsTypes.SortTemplatesSuccess;
  constructor(public payload: FormTemplate[]) {}
}

// #endregion

export class SetFormId implements Action {
  readonly type = FormActionsTypes.SetFormId;
  constructor(public payload: number) {}
}

export class SetCategoryId implements Action {
  readonly type = FormActionsTypes.SetCategoryId;
  constructor(public payload: number) {}
}

// #region Forms
export class PreviewFormTemplate implements Action {
  readonly type = FormActionsTypes.PreviewFormTemplate;
  constructor(public payload: number) {}
}

export class PreviewPhoneFormTemplate implements Action {
  readonly type = FormActionsTypes.PreviewPhoneFormTemplate;
  constructor(public payload: number) {}
}

export class PreviewFormTemplateOpened implements Action {
  readonly type = FormActionsTypes.PreviewFormTemplateOpened;
  constructor(public payload: boolean) {}
}

export class LoadFormTemplateById implements Action {
  readonly type = FormActionsTypes.LoadFormTemplateById;
  constructor(public payload: number) {}
}

export class LoadFormTemplateByIdSuccess implements Action {
  readonly type = FormActionsTypes.LoadFormTemplateByIdSuccess;
  constructor(public payload: FormTemplate) {}
}

export class LoadForms implements Action {
  readonly type = FormActionsTypes.LoadForms;
  constructor(public payload: FormPagerQueryModel) {}
}

export class LoadFormsSuccess implements Action {
  readonly type = FormActionsTypes.LoadFormsSuccess;
  constructor(public payload: any[]) {}
}

export class LoadFormsFail implements Action {
  readonly type = FormActionsTypes.LoadFormsFail;

  constructor(public payload: string) {}
}

export class SearchForms implements Action {
  readonly type = FormActionsTypes.SearchForms;
  constructor(public payload: SearchModel) {}
}

export class SearchGlobalLibraryTemplates implements Action {
  readonly type = FormActionsTypes.SearchGlobalLibraryTemplates;
  constructor(public payload: SearchModel) {}
}

export class SearchAccountLibraryTemplates implements Action {
  readonly type = FormActionsTypes.SearchAccountLibraryTemplates;
  constructor(public payload: SearchModel) {}
}

export class ResetSearch implements Action {
  readonly type = FormActionsTypes.ResetSearch;
  constructor(public payload: SearchType) {}
}

export class ResetGlobalLibrarySearch implements Action {
  readonly type = FormActionsTypes.ResetGlobalLibrarySearch;
}

export class ResetAccountLibrarySearch implements Action {
  readonly type = FormActionsTypes.ResetAccountLibrarySearch;
}

export class ResetSearchSuccess implements Action {
  readonly type = FormActionsTypes.ResetSearchSuccess;
  constructor(public payload: SearchType) {}
}

export class LoadFormsByNameSuccess implements Action {
  readonly type = FormActionsTypes.LoadFormsByNameSuccess;
  constructor(public payload: SearchModel) {}
}

// #endregion

// #region Archive

export class LoadArchive implements Action {
  readonly type = FormActionsTypes.LoadArchive;
}

export class LoadArchiveSuccess implements Action {
  readonly type = FormActionsTypes.LoadArchiveSuccess;

  constructor(public payload: any) {}
}

export class LoadArchiveFail implements Action {
  readonly type = FormActionsTypes.LoadArchiveFail;
  constructor(public payload: string) {}
}

// #endregion

// #region Uploaded

export class LoadUploaded implements Action {
  readonly type = FormActionsTypes.LoadUploaded;
}

export class LoadUploadedSuccess implements Action {
  readonly type = FormActionsTypes.LoadUploadedSuccess;

  constructor(public payload: any) {}
}

export class LoadUploadedFail implements Action {
  readonly type = FormActionsTypes.LoadUploadedFail;
  constructor(public payload: string) {}
}

export class LoadGlobalUploaded implements Action {
  readonly type = FormActionsTypes.LoadGlobalUploaded;
}

export class LoadGlobalUploadedSuccess implements Action {
  readonly type = FormActionsTypes.LoadGlobalUploadedSuccess;

  constructor(public payload: any) {}
}
// #endregion

// #region Uploaded

export class LoadPracticeTemplates implements Action {
  readonly type = FormActionsTypes.LoadPracticeTemplates;
  constructor(public payload?: any) {}
}

export class LoadPracticeTemplatesSuccess implements Action {
  readonly type = FormActionsTypes.LoadPracticeTemplatesSuccess;
  constructor(public payload: any) {}
}

export class LoadPracticeTemplatesFailed implements Action {
  readonly type = FormActionsTypes.LoadPracticeTemplatesFailed;
  constructor(public payload: any) {}
}

export class LoadPracticeArchive implements Action {
  readonly type = FormActionsTypes.LoadPracticeArchive;
  constructor(public payload?: any) {}
}

export class LoadPracticeArchiveSuccess implements Action {
  readonly type = FormActionsTypes.LoadPracticeArchiveSuccess;
  constructor(public payload: any) {}
}

export class LoadPracticeArchiveFailed implements Action {
  readonly type = FormActionsTypes.LoadPracticeArchiveFailed;
  constructor(public payload: any) {}
}

export class FixMediaIssue implements Action {
  readonly type = FormActionsTypes.FixMediaIssue;
  constructor(public payload?: FormTemplate[]) {}
}

// #endregion

// #region Restore

export class RestoreForm implements Action {
  readonly type = FormActionsTypes.RestoreForm;
  constructor(public payload: any) {}
}

export class RestoreFormSuccess implements Action {
  readonly type = FormActionsTypes.RestoreFormSuccess;
  constructor(public payload: any) {}
}

export class RestoreUploadedForm implements Action {
  readonly type = FormActionsTypes.RestoreUploadedForm;
  constructor(public payload: any) {}
}

export class RestoreUploadedFormSuccess implements Action {
  readonly type = FormActionsTypes.RestoreUploadedFormSuccess;
  constructor(public payload: any) {}
}

export class RestorePracticeTemplates implements Action {
  readonly type = FormActionsTypes.RestorePracticeTemplates;
  constructor(
    public payload: FormTemplate[],
    public completed: FormTemplate[] = [],
  ) {}
}

export class RestorePracticeTemplatesSuccess implements Action {
  readonly type = FormActionsTypes.RestorePracticeTemplatesSuccess;
  constructor(public payload: FormTemplate[]) {}
}

// #endregion

export class Reload implements Action {
  readonly type = FormActionsTypes.Reload;
}

export class ResetFormsManagerState implements Action {
  readonly type = FormActionsTypes.ResetFormsManagerState;
}

// #region Error

export class Error implements Action {
  readonly type = FormActionsTypes.Error;
  constructor(public payload: string) {}
}

export class DeleteError implements Action {
  readonly type = FormActionsTypes.DeleteError;
}

//#endregion

// #region Control spinner
export class EnableSpinner implements Action {
  readonly type = FormActionsTypes.EnableSpinner;
}

export class DisableSpinner implements Action {
  readonly type = FormActionsTypes.DisableSpinner;
}
// #endregion

export class ClearBusyTemplates implements Action {
  readonly type = FormActionsTypes.ClearBusyTemplates;
}

export class SelectBusyTemplate implements Action {
  readonly type = FormActionsTypes.SelectBusyTemplate;
  constructor(public payload: number) {}
}

export class AddBusySearchType implements Action {
  readonly type = FormActionsTypes.AddBusySearchType;
  constructor(public payload: SearchType) {}
}

export class RemoveBusySearchType implements Action {
  readonly type = FormActionsTypes.RemoveBusySearchType;
  constructor(public payload: SearchType) {}
}

export class DeselectTemplates implements Action {
  readonly type = FormActionsTypes.DeselectTemplates;
  constructor(public payload: any) {}
}

export class LoadGlobalCategories implements Action {
  readonly type = FormActionsTypes.LoadGlobalCategories;
  constructor(
    public payload: FormCategoryQueryParams = {
      is_stock: true,
      is_deleted: false,
      page: 1,
      page_size: 30,
      ordering: 'order',
    },
  ) {}
}

export class LoadGlobalCategoriesSuccess implements Action {
  readonly type = FormActionsTypes.LoadGlobalCategoriesSuccess;
  constructor(
    public payload: PaginatedApiResponse<FormCategory>,
    /** Page that was actually requested (parsed from `next` URL or explicit param). Used by the
     * reducer to decide merge-vs-replace instead of relying on possibly stale store state. */
    public requestedPage: number = 1,
  ) {}
}

export class LoadMoreGlobalCategories implements Action {
  readonly type = FormActionsTypes.LoadMoreGlobalCategories;
}

export class LoadGlobalCategoriesFail implements Action {
  readonly type = FormActionsTypes.LoadGlobalCategoriesFail;
  constructor(public payload: string) {}
}

export class LoadAccountCategories implements Action {
  readonly type = FormActionsTypes.LoadAccountCategories;
  constructor(
    public payload: FormCategoryQueryParams = {
      is_stock: false,
      is_deleted: false,
      page: 1,
      page_size: 30,
      ordering: 'order',
    },
  ) {}
}

export class LoadAccountCategoriesSuccess implements Action {
  readonly type = FormActionsTypes.LoadAccountCategoriesSuccess;
  constructor(
    public payload: PaginatedApiResponse<FormCategory>,
    /** Page that was actually requested (parsed from `next` URL or explicit param). Used by the
     * reducer to decide merge-vs-replace instead of relying on possibly stale store state. */
    public requestedPage: number = 1,
  ) {}
}

export class LoadMoreAccountCategories implements Action {
  readonly type = FormActionsTypes.LoadMoreAccountCategories;
}

export class LoadAccountCategoriesFail implements Action {
  readonly type = FormActionsTypes.LoadAccountCategoriesFail;
  constructor(public payload: string) {}
}

export class LoadDialogAccountCategories implements Action {
  readonly type = FormActionsTypes.LoadDialogAccountCategories;
}

export class CancelDialogAccountCategories implements Action {
  readonly type = FormActionsTypes.CancelDialogAccountCategories;
}

export class LoadDialogAccountCategoriesSuccess implements Action {
  readonly type = FormActionsTypes.LoadDialogAccountCategoriesSuccess;
  constructor(public payload: FormCategory[]) {}
}

export class LoadDialogAccountCategoriesFail implements Action {
  readonly type = FormActionsTypes.LoadDialogAccountCategoriesFail;
  constructor(public payload: any) {}
}

export class LoadDialogGlobalCategories implements Action {
  readonly type = FormActionsTypes.LoadDialogGlobalCategories;
}

export class CancelDialogGlobalCategories implements Action {
  readonly type = FormActionsTypes.CancelDialogGlobalCategories;
}

export class LoadDialogGlobalCategoriesSuccess implements Action {
  readonly type = FormActionsTypes.LoadDialogGlobalCategoriesSuccess;
  constructor(public payload: FormCategory[]) {}
}

export class LoadDialogGlobalCategoriesFail implements Action {
  readonly type = FormActionsTypes.LoadDialogGlobalCategoriesFail;
  constructor(public payload: any) {}
}

export class SearchGlobalCategories implements Action {
  readonly type = FormActionsTypes.SearchGlobalCategories;
  constructor(public payload: FormCategoryQueryParams) {}
}

export class SearchGlobalCategoriesSuccess implements Action {
  readonly type = FormActionsTypes.SearchGlobalCategoriesSuccess;
  constructor(public payload: PaginatedApiResponse<FormCategory>) {}
}

export class SearchGlobalCategoriesFail implements Action {
  readonly type = FormActionsTypes.SearchGlobalCategoriesFail;
  constructor(public payload: string) {}
}

export class SearchAccountCategories implements Action {
  readonly type = FormActionsTypes.SearchAccountCategories;
  constructor(public payload: FormCategoryQueryParams) {}
}

export class SearchAccountCategoriesSuccess implements Action {
  readonly type = FormActionsTypes.SearchAccountCategoriesSuccess;
  constructor(public payload: PaginatedApiResponse<FormCategory>) {}
}

export class SearchAccountCategoriesFail implements Action {
  readonly type = FormActionsTypes.SearchAccountCategoriesFail;
  constructor(public payload: string) {}
}

export type FormActions =
  | LoadCategoryById
  | LoadCategoryByIdSuccess
  | FilterCategories
  | LoadForms
  | LoadFormsSuccess
  | LoadFormsFail
  | LoadFormTemplateById
  | LoadFormTemplateByIdSuccess
  | PreviewFormTemplate
  | PreviewPhoneFormTemplate
  | PreviewFormTemplateOpened
  | SearchForms
  | SearchGlobalLibraryTemplates
  | SearchAccountLibraryTemplates
  | LoadFormsByNameSuccess
  | ResetSearch
  | ResetGlobalLibrarySearch
  | ResetAccountLibrarySearch
  | ResetSearchSuccess
  | CategoryEntry
  | SetCategoryId
  | SetFormId
  | SelectCategory<any>
  | SelectCategories
  | SelectCategoriesSuccess
  | ResetCategoriesSelection
  | DeselectCategories
  | CreateCategory
  | CreateCategorySuccess
  | CreateCategoryFail
  | UpdateCategory
  | UpdateCategorySuccess
  | UpdateCategoryFail
  | DeleteCategory
  | DeleteCategorySuccess
  | DeleteCategoryFail
  | SortCategory
  | SortCategorySuccess
  | CreateForm
  | CreateFormSuccess
  | CreateFormFail
  | CloneForm
  | CloneFormSuccess
  | UpdateForm
  | UpdateFormSuccess
  | UpdateFormFail
  | PublishTemplates
  | PublishTemplatesSuccess
  | StopPublishingTemplates
  | StopPublishingTemplatesSuccess
  | DeleteForms
  | DeleteFormsSuccess
  | DeleteFormsFail
  | DeleteFormTemplatesById
  | DeleteFormTemplatesByIdSuccess
  | RecalculateCategoryCountsAfterArchive
  | RecalculateCategoryCountsAfterMove
  | RecalculateCategoryCountsAfterClone
  | CloneForms
  | CloneFormsSuccess
  | CloneFormsUsingIds
  | SaveAsCopy
  | SaveAsCopySuccess
  | MoveForm
  | MoveFormBulk
  | MoveFormSuccess
  | MoveTemplatesLocallySuccess
  | AddClonedTemplatesLocallySuccess
  | SortTemplates
  | SortTemplatesSuccess
  | LoadArchive
  | LoadArchiveSuccess
  | LoadArchiveFail
  | LoadUploaded
  | LoadUploadedSuccess
  | LoadUploadedFail
  | LoadGlobalUploaded
  | LoadGlobalUploadedSuccess
  | LoadPracticeTemplates
  | LoadPracticeTemplatesSuccess
  | LoadPracticeTemplatesFailed
  | LoadPracticeArchive
  | LoadPracticeArchiveSuccess
  | LoadPracticeArchiveFailed
  | RestoreForm
  | RestoreFormSuccess
  | RestoreUploadedForm
  | RestoreUploadedFormSuccess
  | RestorePracticeTemplates
  | RestorePracticeTemplatesSuccess
  | LoadSelectedTemplate
  | SetSelectedTemplate
  | Reload
  | ResetFormsManagerState
  | Error
  | DeleteError
  | EnableSpinner
  | DisableSpinner
  | FixMediaIssue
  | DeselectCategoryByType
  | ClearBusyTemplates
  | SelectBusyTemplate
  | AddBusySearchType
  | RemoveBusySearchType
  | DeselectTemplates
  | LoadGlobalCategories
  | LoadMoreGlobalCategories
  | LoadGlobalCategoriesSuccess
  | LoadGlobalCategoriesFail
  | LoadAccountCategories
  | LoadMoreAccountCategories
  | LoadAccountCategoriesSuccess
  | LoadAccountCategoriesFail
  | LoadDialogAccountCategories
  | CancelDialogAccountCategories
  | LoadDialogAccountCategoriesSuccess
  | LoadDialogAccountCategoriesFail
  | LoadDialogGlobalCategories
  | CancelDialogGlobalCategories
  | LoadDialogGlobalCategoriesSuccess
  | LoadDialogGlobalCategoriesFail
  | SearchGlobalCategories
  | SearchGlobalCategoriesSuccess
  | SearchGlobalCategoriesFail
  | SearchAccountCategories
  | SearchAccountCategoriesSuccess
  | SearchAccountCategoriesFail;
